import { render } from "./base-left-sub-menu.vue?vue&type=template&id=3bc59b86"
import script from "./base-left-sub-menu.vue?vue&type=script&lang=js"
export * from "./base-left-sub-menu.vue?vue&type=script&lang=js"
script.render = render

export default script